var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStockChain1CWhiteLogomark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 60,
    viewBox: "0 0 82 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2678 0L0 16.9983L13.5832 24.8404V20.9029L16.9706 18.9469L13.5661 16.9813L29.274 7.85844L67.4559 29.9692L51.7578 39.0317L25.3864 23.8057L21.9985 25.7605V29.6986L44.9598 42.9548L29.2702 52.0139L1.11418 35.805V43.6497L29.2716 59.8638L81.0383 29.9766L29.2678 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0083 37.5106L29.1944 39.7147L20.7378 34.8355V25.0322L29.1944 20.153L40.5757 26.722V19.9179L29.1944 13.3449L14.8438 21.6301V38.2376L29.1944 46.5228L38.9044 40.9147L33.0083 37.5106Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81.0383,
    height: 59.8638,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockChain1CWhiteLogomark);
export default __webpack_public_path__ + "static/media/StockChain1CWhiteLogomark.90ee1549e59bb1f13022a51763e92aba.svg";
export { ForwardRef as ReactComponent };